import {
  GET_NOTIFICATIONRESPONSIBLE,
  GET_NOTIFICATIONRESPONSIBLE_FAIL,
  GET_NOTIFICATIONRESPONSIBLE_SUCCESS,
  GET_NOTIFICATIONRESPONSIBLES,
  GET_NOTIFICATIONRESPONSIBLES_FAIL,
  GET_NOTIFICATIONRESPONSIBLES_SUCCESS,
  ADD_NEW_NOTIFICATIONRESPONSIBLE,
  ADD_NOTIFICATIONRESPONSIBLE_SUCCESS,
  ADD_NOTIFICATIONRESPONSIBLE_FAIL,
  UPDATE_NOTIFICATIONRESPONSIBLE,
  UPDATE_NOTIFICATIONRESPONSIBLE_SUCCESS,
  UPDATE_NOTIFICATIONRESPONSIBLE_FAIL,
  DELETE_NOTIFICATIONRESPONSIBLE,
  DELETE_NOTIFICATIONRESPONSIBLE_SUCCESS,
  DELETE_NOTIFICATIONRESPONSIBLE_FAIL,
  SET_STATE_NOTIFICATIONRESPONSIBLE
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_NOTIFICATIONRESPONSIBLE,
  payload: loading,
})

export const getNotificationResponsibles = ( params ) => ({
  type: GET_NOTIFICATIONRESPONSIBLES,
  payload: { params },
})

export const getNotificationResponsiblesSuccess = (notificationResponsibles, totalPages, currentPage) => ({
  type: GET_NOTIFICATIONRESPONSIBLES_SUCCESS,
  payload: { notificationResponsibles:notificationResponsibles, total:totalPages, currentPage:currentPage}
})

export const getNotificationResponsiblesFail = error => ({
  type: GET_NOTIFICATIONRESPONSIBLES_FAIL,
  payload: error,
})

export const addNewNotificationResponsible = notificationResponsible => ({
  type: ADD_NEW_NOTIFICATIONRESPONSIBLE,
  payload: notificationResponsible,
})

export const addNotificationResponsibleSuccess = notificationResponsible => ({
  type: ADD_NOTIFICATIONRESPONSIBLE_SUCCESS,
  payload: notificationResponsible,
})  

export const addNotificationResponsibleFail = error => ({
  type: ADD_NOTIFICATIONRESPONSIBLE_FAIL,
  payload: error,
})

export const updateNotificationResponsible = notificationResponsible => ({
  type: UPDATE_NOTIFICATIONRESPONSIBLE,
  payload: notificationResponsible,
})

export const updateNotificationResponsibleSuccess = notificationResponsible => ({
  type: UPDATE_NOTIFICATIONRESPONSIBLE_SUCCESS,
  payload: notificationResponsible,
})

export const updateNotificationResponsibleFail = error => ({
  type: UPDATE_NOTIFICATIONRESPONSIBLE_FAIL,
  payload: error,
})

export const deleteNotificationResponsible = notificationResponsible => ({
  type: DELETE_NOTIFICATIONRESPONSIBLE,
  payload: notificationResponsible,
})

export const deleteNotificationResponsibleSuccess = id => ({
  type: DELETE_NOTIFICATIONRESPONSIBLE_SUCCESS,
  id,
})

export const deleteNotificationResponsibleFail = error => ({
  type: DELETE_NOTIFICATIONRESPONSIBLE_FAIL,
  payload: error,
})

export const getNotificationResponsible = () => ({
  type: GET_NOTIFICATIONRESPONSIBLE,
})

export const getNotificationResponsibleSuccess = notificationResponsible => ({
  type: GET_NOTIFICATIONRESPONSIBLE_SUCCESS,
  payload: notificationResponsible,
})

export const getNotificationResponsibleFail = error => ({
  type: GET_NOTIFICATIONRESPONSIBLE_FAIL,
  payload: error,
})
